import { ArrowRight, FileText, Scale, CheckCircle2 } from "lucide-react";
import { PageHero, Eyebrow, PrimaryButton, GoldButton } from "@/components/Ui";
import { SERVICES, CAF_SERVICES, FORMAZIONE } from "@/data/content";

const Servizi = () => (
  <div data-testid="servizi-page">
    <PageHero eyebrow="I nostri servizi" title="Assistenza dedicata per ogni esigenza" subtitle="Schede di dettaglio per ogni servizio: dalle graduatorie alla formazione, dal CAF e Patronato ai ricorsi." />

    {/* Main services */}
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <div key={s.id} id={s.id} data-testid={`service-card-${s.id}`} className="group bg-white border border-gray-100 p-8 shadow-crisp hover:shadow-crisp-lg hover:border-gold-500 transition-all duration-300">
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-navy-900 group-hover:bg-gold-500 flex items-center justify-center shrink-0 transition-colors duration-300">
                  <s.icon className="w-7 h-7 text-gold-500 group-hover:text-navy-900 transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-xs text-gold-600 font-bold uppercase tracking-[0.14em]">Servizio {String(i + 1).padStart(2, "0")}</div>
                  <h3 className="mt-1 font-serif text-2xl font-semibold text-navy-900">{s.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CAF e Patronato */}
    <section className="bg-[#F8F9FA] py-20 md:py-28" id="caf-patronato">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14">
        <div>
          <Eyebrow>Servizio 09</Eyebrow>
          <h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-navy-900">CAF e Patronato</h2>
          <p className="mt-5 text-slate-600 leading-relaxed">Un servizio completo di assistenza fiscale e previdenziale per il personale scolastico e le famiglie, con operatori qualificati.</p>
          <div className="mt-8"><PrimaryButton to="/prenota">Prenota un appuntamento CAF</PrimaryButton></div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {CAF_SERVICES.map((c, i) => (
            <div key={c} data-testid={`caf-item-${i}`} className="bg-white border border-gray-100 px-5 py-4 flex items-center gap-3 shadow-crisp">
              <CheckCircle2 className="w-5 h-5 text-gold-500 shrink-0" />
              <span className="font-semibold text-navy-900 text-sm">{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Ricorsi */}
    <section className="bg-navy-900 py-20 md:py-28 relative overflow-hidden" id="ricorsi">
      <div className="absolute inset-0 noise-overlay opacity-[0.05]" />
      <div className="relative max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <div className="w-14 h-14 mx-auto bg-gold-500 flex items-center justify-center"><Scale className="w-7 h-7 text-navy-900" /></div>
        <Eyebrow light>Servizio 10</Eyebrow>
        <h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-white">Ricorsi e tutela legale</h2>
        <p className="mt-5 text-white/75 leading-relaxed max-w-2xl mx-auto">
          Assistenza nei ricorsi scolastici e nelle azioni di tutela legale: graduatorie, punteggi, esclusioni, mobilità e ricostruzione di carriera. Ti affianchiamo con un supporto qualificato per far valere i tuoi diritti.
        </p>
        <div className="mt-8"><GoldButton to="/prenota">Richiedi assistenza legale <ArrowRight className="w-4 h-4" /></GoldButton></div>
      </div>
    </section>

    {/* Formazione preview */}
    <section className="bg-white py-20 md:py-28" id="formazione">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl"><Eyebrow>Servizio 11</Eyebrow><h2 className="mt-3 font-serif text-4xl md:text-5xl font-medium text-navy-900">Formazione e certificazioni</h2></div>
        <div className="mt-10 flex flex-wrap gap-3">
          {FORMAZIONE.map((f, i) => (
            <span key={f} data-testid={`formazione-tag-${i}`} className="border border-gray-200 hover:border-gold-500 px-5 py-3 text-sm font-semibold text-navy-900 transition-colors duration-200">{f}</span>
          ))}
        </div>
        <div className="mt-10"><PrimaryButton to="/formazione">Scopri i percorsi formativi <ArrowRight className="w-4 h-4" /></PrimaryButton></div>
      </div>
    </section>
  </div>
);

export default Servizi;
